(function () {
    'use strict';

    angular
        .module('actionPlanEditModule')
        .controller('ActionPlanEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'historyCtxtService', 'recommendation', 'actionPlan', 'actionPlanCriterias'];

    function Controller($scope, $state, $stateParams, historyCtxtService, recommendation, actionPlan, actionPlanCriterias) {

        $scope.recommendation = recommendation;
        $scope.actionPlan = actionPlan;
        $scope.actionPlanCriterias = actionPlanCriterias;

        initPermissions();

        // Go to Recommendation
        $scope.goToRecommendation = function () {
            $state.go('recommendation.edit', {
                RecommendationID: recommendation.RecommendationID
            }, {
                reload: true
            });
        };

        // Go to Action Plan Criteria
        $scope.goToActionPlanCriteria = function (item) {

            historyCtxtService.goToState('actionPlanCriteriaEdit', {
                    ActionPlanCriteriaID: item.ActionPlanCriteriaID,
                    ActionPlanID: actionPlan.ActionPlanID
                },
                'recommendation.edit.actionPlan.edit',
                actionPlan
            );
        };

        // Check if list of Action Plan Criterias should be displayed
        $scope.canViewCriterias = function () {
            if (!$scope.actionPlan.ActionPlanID) return false;

            return $scope.actionPlan.HasActionPlan_ViewActionPlanCriterias;
        };

        function initPermissions() {
            $scope.boxModelPermission = $scope.actionPlan;
            $scope.boxPermissionKey = 'ActionPlan';
            $scope.boxClickablePermission = 'ViewActionPlanCriterias';
        }
    }
})();